import { type as types } from "../types/index";

const getInitialSucursal = () => {
    const raw = sessionStorage.getItem("sucursalSeleccionada");
    if (!raw || raw === "undefined" || raw === "null") return null;
    try {
        return JSON.parse(raw);
    } catch (e) {
        sessionStorage.removeItem("sucursalSeleccionada");
        return null;
    }
};

const sucursalSeleccionada = getInitialSucursal();
const initialState = sucursalSeleccionada ? { sucursalSeleccionada } : { sucursalSeleccionada: null}

export const SucursalesReducer = (state = initialState, action) => {

    const {type, payload } = action;
    
    switch (type) {
        case types.updateSucursalSelection:
            const result = {
                sucursalSeleccionada: payload
            };
            return result;
        default:
            return state;
    }
}
